import SessionVideoPlayer from '../SessionVideoPlayer';

function traits() {
  return [
    {
      type: 'text',
      name: 'id',
      label: 'ID',
      value: `session-video-player-${crypto.randomUUID()}`,
    },
    {
      type: 'text',
      name: 'playlist_id',
      label: 'Playlist ID',
      value: 'playList-0c627028-b44c-4ede-8699-ad757af8508d',
    },
    {
      type: 'text',
      name: 'session_id',
      label: 'Session ID',
      value: 'gtc25-s72484',
    },
  ];
}

function componentDefinition(editor, options) {
  const { componentType, componentName } = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: SessionVideoPlayer,
        traits: traits(),
      },
    },
    isComponent: (el) => el.tagName === componentType.toUpperCase(),
  };
}

export default function loadComponent(editor, options = {}) {
  editor.Components.addType(
    options.componentType,
    componentDefinition(editor, options)
  );
}
